






import { defineComponent } from '@vue/composition-api';

/**
 * ## フレックス行コンテナ
 *
 * 複数の要素を渡した際は`space-between`で均等に間隔をあけ配置し、各要素の幅は`grow`させる。
 * VuetifyのGrid system（v-container, v-col, v-row）は今回のデザインでは利用しない。
 * 特に恩恵がなく、ライブラリ依存度が高くなるため。
 *
 */
export default defineComponent({
  name: 'AppRow',

  setup() {
    return {};
  },
});
